import { Validators } from '@angular/forms';
import { PaymentProcessesEnum, PaymentReportModel } from '@spa/api';
import { EnumsHelper } from 'appShared/classes/common/helpers';

import { AmountControl, BaseControl, DatepickerControl, SelectControl } from '../../app/shared/classes/controls';
import { ComponentTypesEnum } from '../../app/shared/enums/common';

export const PaymentsAmountSelector = 'amount';
export const PaymentsCategorySelector = 'category';
export const PaymentsCommentSelector = 'comment';
export const PaymentsCreateDateSelector = 'createDate';

export interface PaymentsFormControlsInterface {
    amount: AmountControl;
    category?: SelectControl;
    comment?: BaseControl;
    createDate?: DatepickerControl;
}

export const PaymentsFormControls = (payment: PaymentReportModel): PaymentsFormControlsInterface => {
    const controls: PaymentsFormControlsInterface = {
        amount: new AmountControl({
            name: PaymentsAmountSelector,
            value: null,
            placeholder: 'Amount',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: '',
            floatingLabelNever: true,
            fourDecimals: true
        })
    };

    if (payment.paymentProcess === PaymentProcessesEnum.Adjustment) {
        controls.category = new SelectControl({
            name: PaymentsCategorySelector,
            value: payment.category,
            placeholder: 'Category',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: EnumsHelper.getAdjustmentCategoryOptions(),
            floatingLabelNever: true
        });

        controls.comment = new BaseControl({
            name: PaymentsCommentSelector,
            value: payment.description,
            placeholder: 'Comment',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            readonly: false,
            floatingLabelNever: true
        });

        controls.createDate = new DatepickerControl({
            name: PaymentsCreateDateSelector,
            value: payment.createDate,
            placeholder: 'Create Date',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Datepicker,
            readonly: false,
            floatingLabelNever: true
        });
    }

    return controls;
};
